<template>
	<div class="page-wrapper">
		<b-container fluid>
			<!--<div class="page-titles" style="position: fixed; z-index: 9; width: 100%;">
				<div class="row">
				<div class="align-self-center col-md-5">
					<h4 class="text-themecolor">Add Article</h4>
				</div>
				<div class="align-self-center text-right col-md-7">
					<div class="d-flex justify-content-end align-items-center">
						<ol class="breadcrumb">
							<li class="breadcrumb-item active">
								<span aria-current="location">Add Article</span>
							</li>
						</ol>
						<div class="ml-2">
							<div class="ml-2"><a href="/kamus-keuangan" class="btn m-l-15 btn-success"
							target="_self">Posts List</a></div>
						</div>
					</div>
				</div>
				</div>
			</div>-->
			<bo-page-title>
				<div class="ml-2">
					<b-button class="" variant="default" @click="cancelAddUpdate">Cancel
					</b-button>
					<b-button class="ml-2" variant="light" @click="cancelAddUpdate">Save Draft
					</b-button>
					<b-button class="ml-2" variant="light" @click="cancelAddUpdate">Preview
					</b-button>
					<b-button class="ml-2" variant="success" type="submit">Publish</b-button>
				</div>
			</bo-page-title>
			<template>
				<b-form @submit.prevent="handleSubmit">
					<b-tabs>
						<b-tab title="Article Content">
							<b-card no-body>
								<b-card-body>
									<b-row>
										<b-col lg="8">
											<b-row>
												<b-col lg="12">
													<b-form-group label-for="articleTitle">
														<template #label>Title<span
																class="text-danger mr5">*</span></template>
														<b-form-input id="articleTitle" v-model="articleRow.title"
															placeholder="e.g. Pilih Penerbangan Pagi, Sebuah Tips dari Pramugari" />
													</b-form-group>
												</b-col>
												<b-col lg="8">
													<b-form-group label-for="articleTitle">
														<template #label>Slug<span
																class="text-danger mr5">*</span></template>
														<b-form-input id="articleTitle" v-model="articleRow.title"
															placeholder="e.g https://" />
													</b-form-group>
												</b-col>
												<b-col lg="12">
													<b-form-group label-for="articleCat">
														<b-row>
															<b-col lg="9">
																<label for="articleTitle" class="d-block">Category<span
																		class="text-danger mr5">*</span></label>
																<v-select multiple v-model="selected"
																	:options="['Accommodation ','Xperience','Flight']" />
															</b-col>
															<b-col md="auto" style="padding-left:0;">
																<label for="articleTitle" class="d-block"
																	style="color:#fff;"> lbl <span
																		class="text-danger mr5"></span></label>
																<b-button-group>
																	<b-button v-b-modal.modal-1><i
																			class="mr-2 fas fa-plus"></i> Add Category
																	</b-button>
																	<b-modal id="modal-1" title="Add New Category">
																		<b-row>
																			<b-col lg="12">
																				<b-form-group label-for="catName">
																					<label>Category Name<span
																							class="text-danger mr5">*</span></label>
																					<b-form-input id="catName"
																						placeholder="e.g Bank Digital" />
																				</b-form-group>
																			</b-col>
																			<b-col lg="12">
																				<b-form-group label-for="articleTitle">
																					<template
																						#label>Description</template>
																					<b-form-textarea id="textarea"
																						v-model="text"
																						placeholder="Enter something..."
																						rows="4" max-rows="4">
																					</b-form-textarea>
																				</b-form-group>
																			</b-col>
																			<b-col lg="12">
																				<b-form-group label-for="catStatus">
																					<label>Parent Category<span
																							class="text-danger mr5">*</span></label>
																					<v-select
																						placeholer="Select Category"
																						v-model="selected_parent"
																						:options="parent" />
																				</b-form-group>
																			</b-col>
																			<b-col lg="8">
																				<b-form-group label-for="articleTitle">
																					<template #label>Slug<span
																							class="text-danger mr5">*</span></template>
																					<b-form-input id="articleTitle"
																						v-model="articleRow.title"
																						placeholder="e.g https://" />
																				</b-form-group>
																			</b-col>
																			<b-col lg="12" class="mb-2">
																				<bo-uploader
																					:img-src="articleRow.thumbnail">
																					<template #label>Image <span
																							class="text-danger ml5">*</span></template>
																				</bo-uploader>
																			</b-col>
																		</b-row>
																		<template #modal-footer>
																			<div class="w-100">
																				<b-button variant="success"
																					class="float-right">
																					Save
																				</b-button>
																			</div>
																		</template>
																	</b-modal>
																</b-button-group>
															</b-col>
														</b-row>
													</b-form-group>
												</b-col>

												<b-col lg="12">
													<b-form-group label-for="articleContent">
														<template #label>Content <span
																class="text-danger mr5">*</span></template>
														<CKEditor :value="articleRow.content" />
													</b-form-group>
												</b-col>

												<b-col lg="12">
													<b-form-group label-for="articleTitle">
														<template #label>Write an excerpt (optional)</template>
														<b-form-textarea id="textarea" v-model="text"
															placeholder="Enter something..." rows="4" max-rows="4">
														</b-form-textarea>
													</b-form-group>
												</b-col>

												<b-col lg="9">
													<b-form-group label-for="articleTags">
														<template #label>Tags <span
																class="text-danger mr5">*</span></template>
														<b-form-tags v-model="articleRow.tags" id="articleTags" />
														<small>Separate with commas or the Enter key.
														</small>
													</b-form-group>
													<b-row>
														<b-col lg="12">
															<div class="wrap_most_used">
																<h3>Most used tags</h3>
																<ul>
																	<li><a href="">Holiday</a></li>
																	<li><a href="">Traveloka</a></li>
																	<li><a href="">Jalan-Jalan</a></li>
																	<li><a href="">Staycation</a></li>
																	<li><a href="">Healing</a></li>
																	<li><a href="">Liburan Keluarga</a></li>
																	<li><a href="">Wisata</a></li>
																	<li><a href="">Tiket Murah</a></li>
																</ul>
															</div>
														</b-col>
													</b-row>
												</b-col>
											</b-row>
										</b-col>
										<b-col lg="4">
											<div class="side_wrap">
												<b-row>
													<b-col lg="12" class="mb-2">
														<bo-uploader :img-src="articleRow.thumbnail">
															<template #label>Image <span
																	class="text-danger ml5">*</span></template>
														</bo-uploader>
													</b-col>

													<b-col lg="12" class="mb-2">
														<b-form-group>
															<label>Alt Image<span
																	class="text-danger mr5">*</span></label>
															<b-form-input id="input-formatter" v-model="text1"
																placeholder="e.g Image title" :formatter="formatter">
															</b-form-input>
														</b-form-group>
													</b-col>

													<b-col lg="12" class="mb-2">
														<b-form-group label-for="articleAuthor">
															<template #label>Author<span
																	class="text-danger mr5">*</span></template>
															<b-form-input id="articleAuthor" v-model="articleRow.author"
																placeholder="e.g Administrator" />
														</b-form-group>
													</b-col>

													<b-col lg="12" class="mb-2">
														<b-form-group label-for="articlePubDate">
															<template #label>Publish Date<span
																	class="text-danger mr5">*</span></template>
															<v-date-picker v-model="date">
																<template v-slot="{ inputValue, inputEvents }">
																	<input class="bg-white custom_inp px-2 py-1 rounded"
																		:value="inputValue" v-on="inputEvents" />
																</template>
															</v-date-picker>
														</b-form-group>
													</b-col>

													<b-col lg="12">
														<b-form-group label-for="articleStatus">
															<template #label>Featured Article<span
																	class="text-danger mr5">*</span></template>
															<b-form-checkbox id="checkbox-1" v-model="featured"
																name="checkbox-1" value="accepted"
																unchecked-value="not_accepted">
																Set As Featured Article
															</b-form-checkbox>
														</b-form-group>
													</b-col>

													<b-col lg="12">
														<b-form-group>
															<label>Make Featured Article Sticky?<span
																	class="text-danger mr5">*</span></label>
															<b-form-radio-group v-model="selected_comment"
																:options="comment" value-field="item" text-field="name"
																disabled-field="notEnabled">
															</b-form-radio-group>
														</b-form-group>
													</b-col>

													<b-col lg="12">
														<b-form-group>
															<label>Allow Share Story? <span
																	class="text-danger mr5">*</span></label>
															<b-form-radio-group v-model="selected_comment"
																:options="comment" value-field="item" text-field="name"
																disabled-field="notEnabled">
															</b-form-radio-group>
														</b-form-group>
													</b-col>
												</b-row>
											</div>
										</b-col>
									</b-row>
								</b-card-body>
							</b-card>
						</b-tab>

						<b-tab title="SEO Settings">
							<b-card>
								<b-row>
									<b-col lg="12">
										<b-form-group label-for="homeMetaTitle">
											<template #label>
												Meta Title
												<b-badge variant="info" pill class="help-badge"
													v-b-tooltip.hover.right="'This field functions to ease Google understand the title of this website page. Pro tip: Make sure the characters length is less than 70 chars.'">
													<i class="fas fa-question"></i>
												</b-badge>
											</template>
											<b-form-input id="homeMetaTitle" placeholder="Meta Title"
												v-model="seoRow.title" />
										</b-form-group>
									</b-col>
									<b-col lg="9">
										<b-form-group label-for="homeMetaDesc">
											<template #label>
												Meta Description
												<b-badge variant="info" pill class="help-badge"
													v-b-tooltip.hover.right="'This field functions to ease Google understand the title of this website page. Pro tip: Make sure the characters length is less than 70 chars.'">
													<i class="fas fa-question"></i>
												</b-badge>
											</template>
											<b-form-textarea rows="4" id="homeMetaDesc" placeholder="Meta Description"
												v-model="seoRow.description" />
										</b-form-group>
									</b-col>
									<b-col lg="9">
										<b-form-group label-for="homeMetaTags">
											<template #label>
												Meta Tags
												<b-badge variant="info" pill class="help-badge"
													v-b-tooltip.hover.right="'This field functions to ease Google understand the title of this website page. Pro tip: Make sure the characters length is less than 70 chars.'">
													<i class="fas fa-question"></i>
												</b-badge>
											</template>
											<b-form-tags id="homeMetaTags" placeholder="Type and press enter ..."
												remove-on-delete tag-variant="success" tag-class="text-white"
												v-model="seoRow.keywords" />
										</b-form-group>
									</b-col>
									<b-col lg="7">
										<b-form-group label-for="homeMetaTitle">
											<template #label>
												Canonical URL
												<b-badge variant="info" pill class="help-badge"
													v-b-tooltip.hover.right="'A canonical URL is the URL of the page that Google thinks is most representative from a set of duplicate pages on your site.'">
													<i class="fas fa-question"></i>
												</b-badge>
											</template>
											<b-form-input id="homeMetaTitle" placeholder="e.g https://duwitmu.com/"
												v-model="seoRow.title" />
										</b-form-group>
									</b-col>
								</b-row>
							</b-card>
						</b-tab>
					</b-tabs>
					<b-card no-body>
						<template #footer>
							<div class="text-right">
								<b-button class="" variant="default" @click="cancelAddUpdate">Cancel
								</b-button>
								<b-button class="ml-2" variant="light" @click="cancelAddUpdate">Save Draft
								</b-button>
								<b-button class="ml-2" variant="light" @click="cancelAddUpdate">Preview
								</b-button>
								<b-button class="ml-2" variant="success" type="submit">Publish</b-button>
							</div>
						</template>
					</b-card>
				</b-form>
			</template>
		</b-container>
	</div>
</template>
<script>
	import BoUploader from '@/components/BoUploader.vue'
	import GlobalVue from '@/libs/Global.vue'
	import CKEditor from '@/components/CKEditor.vue'

	export default {
		name: 'Article',
		extends: GlobalVue,
		components: {
			BoUploader,
			CKEditor: CKEditor
		},

		mounted() {
			this.loadSeoData()
			this.loadArticleData()
		},

		computed: {
			dataSrc() {
				return this.dummyData.article
			},
		},

		methods: {
			loadSeoData() {
				let datas = this.dataSrc.seo
				this.seoRow = datas
			},
			loadArticleData() {
				let datas = this.dataSrc.articleList
				datas.forEach(el => {
					this.articleData.push(el)
				})
			}
		},
		data() {
			return {
				selected: 'A',
				ads_device: [{
						item: 'A',
						name: 'Desktop'
					},
					{
						item: 'B',
						name: 'Mobile'
					}
				],
				date: new Date(),
				days: [],
				featured: 'not_accepted',
				seoRow: {},
				articleRow: {
				content: ``
				},
				articleData: [],
				rows: 30,
				perPage: 1,
				currentPage: 5,
				selected_category: 'All Category',
				category: [
					'All Category',
					'Pinjaman Online',
					'Asuransi',
					'Bank Digital',
					'Investasi',
					'Rencana Keuangan',
				],
				selected_sort: 'Sort By',
				sort: [
					'Sort By',
					'Most Viewed',
					'Least Viewed',
					'Oldest',
					'Newest',
				],
				selected_ads_size: 'Select Ads Size',
				ads_size: [
					'Select Ads Size',
					'300x250',
					'336x280',
					'728x90',
					'300x600',
					'320x100',
					'200x50',
					'320x20',
				],
				selected_parent: ' ---Select Parent Catgeory ---',
				parent: [
					' ---Select Parent Catgeory ---',
					'Asuransi',
					'Advetorial',
					'Pengeluaran',
					'Saham'
				],
				selected_comment: 'Y',
				comment: [{
						item: 'Y',
						name: 'Yes'
					},
					{
						item: 'N',
						name: 'No'
					}
				],
			}
		},
		watch: {
			$route() {
				if (!this.isList) {
					if (!this.isAdd) {
						this.articleRow = this.articleData.find(el => el.id == this.$route.params.slug)
						console.log(this.articleRow)
					} else {
						this.articleRow = {}
					}
				}
			}
		}
	}
</script>